"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withOpacity = exports.hexToRgb = exports.getMediaQuery = void 0;

var getMediaQuery = function getMediaQuery(pixelValue) {
  return "@media (min-width: " + pixelValue + "px)";
};

exports.getMediaQuery = getMediaQuery;

var hexToRgb = function hexToRgb(input) {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  var hex = input.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : {};
};

exports.hexToRgb = hexToRgb;

var withOpacity = function withOpacity(hex, opacity) {
  if (opacity === void 0) {
    opacity = 1;
  }

  var rgbValue = exports.hexToRgb(hex);
  return "rgba(" + Object.values(rgbValue).join(',') + "," + opacity + ")";
};

exports.withOpacity = withOpacity;